<script lang="ts" setup>
import type { SnakeCaseAddressInfo } from '@/components/AddressPicker/types'
import { useVModel } from '@vueuse/core'
import { ElMessage, type FormInstance, type FormRules } from 'element-plus'
import { reactive, ref } from 'vue'
import { updateShopInfo } from '@/api/login'
import AddressPicker from '@/components/AddressPicker/index.vue'
import { useUserStore } from "@/store/modules/user"

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const show = useVModel(props, 'modelValue', emit)

const userStore = useUserStore()
const shopInfo = ref(userStore.getShopInfo())
const backup = JSON.parse(JSON.stringify(userStore.getShopInfo()))
const formRef = ref<FormInstance>()

const rules = reactive<FormRules<typeof shopInfo.value>>({
  shopName: [{ required: true, message: '请输入门店名称', trigger: 'blur' }],
  contactName: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
  contactPhone: [{ required: true, message: '请输入联系人电话', trigger: 'blur' }],
  shopLocation: [{ required: true, message: '请输入门店地址', trigger: 'blur' }],
  shopAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
})

const handleSave = async () => {
  if (!formRef.value) return
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      updateShopInfo(shopInfo.value).then(() => {
        ElMessage.success('信息保存成功')
        show.value = false
      })
    } else {
      console.error('表单验证失败:', fields)
    }
  })
}

const location = ref<SnakeCaseAddressInfo>(JSON.parse(shopInfo.value?.shopLocation || '{}'))

const handleLocationChange = (loc: SnakeCaseAddressInfo) => {
  shopInfo.value.shopLocation = JSON.stringify(loc)
}

const handleClose = () => {
  userStore.setShopInfo(backup)
  show.value = false
}
</script>

<template>
  <el-dialog
    title="门店信息"
    v-model="show"
    width="600"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="shopInfo"
      :rules="rules"
      label-width="120px"
      class="custom-form-align-right custom-form-underline"
      require-asterisk-position="right"
    >
      <el-form-item label="门店名称" prop="shopName">
        <el-input v-model.trim="shopInfo.shopName" />
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactName">
        <el-input v-model.trim="shopInfo.contactName" />
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactPhone">
        <el-input v-model.trim="shopInfo.contactPhone" />
      </el-form-item>
      <el-form-item label="门店地址" prop="shopLocation">
        <AddressPicker
          v-model="location"
          @update:model-value="handleLocationChange"
        />
      </el-form-item>
      <el-form-item label="详细地址" prop="shopAddress">
        <el-input v-model.trim="shopInfo.shopAddress" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose" style=" min-width: 88px;height: 40px">取消</el-button>
        <el-button type="primary" @click="handleSave" style=" min-width: 88px;height: 40px">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
